import { fromJS } from 'immutable';
import { requestHelp, requestHelpUpdate } from './types';
import { combineReducerArray } from '../utils/helpers';

export * from './actions';

const initialState = fromJS({
  network: {
    loading: true,
    error: false,
  },
  isInvited: false,
});

const requestHelpReducersObject = {
  [requestHelp.request]: (state) =>
    state.withMutations((currentState) =>
      currentState.setIn(['network', 'loading'], true).setIn(['network', 'error'], false),
    ),
  [requestHelp.success]: (state, action) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['network', 'loading'], false)
        .setIn(['network', 'error'], false)
        .setIn(['response'], action.response),
    ),
  [requestHelp.failure]: (state, action) =>
    state.withMutations((currentState) =>
      currentState.setIn(['network', 'loading'], false).setIn(['network', 'error'], action),
    ),
  [requestHelpUpdate.request]: (state) =>
    state.withMutations((currentState) =>
      currentState.setIn(['network', 'loading'], true).setIn(['network', 'error'], false),
    ),
  [requestHelpUpdate.success]: (state) =>
    state.withMutations((currentState) =>
      currentState
        .setIn(['network', 'loading'], false)
        .setIn(['network', 'error'], false)
        .set('isInvited', true),
    ),
  [requestHelpUpdate.failure]: (state, action) =>
    state.withMutations((currentState) =>
      currentState.setIn(['network', 'loading'], false).setIn(['network', 'error'], action),
    ),
};

export default combineReducerArray(initialState, [requestHelpReducersObject]);
